import React from 'react';
import { Gift, Check } from 'lucide-react';
interface BonusCardProps {
  bonusNumber: number;
  title: string;
  description?: string;
  features?: string[];
  imageSrc?: string;
}
export function BonusCard({
  bonusNumber,
  title,
  description,
  features,
  imageSrc
}: BonusCardProps) {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300 max-w-4xl mx-auto mb-8" data-id="element-124">
      <div className="p-8 md:flex items-center gap-8" data-id="element-125">
        {/* Left side: Visual representation (Product Box) */}
        <div className="w-full md:w-1/3 flex justify-center mb-6 md:mb-0" data-id="element-126">
          {imageSrc ? <img src={imageSrc} alt={title} className="w-full max-w-[250px] h-auto object-contain" data-id="element-127" /> : <div className="relative w-48 h-64 bg-gradient-to-br from-gray-900 to-black rounded-lg transform rotate-y-12 shadow-2xl flex flex-col items-center justify-center text-center p-4 border-l-4 border-green-500" data-id="element-128">
              <div className="absolute top-4 bg-green-500 text-black font-bold px-3 py-1 rounded-full text-sm" data-id="element-129">
                BONO {bonusNumber}
              </div>
              <h3 className="text-white font-bold text-xl mt-4 leading-tight uppercase" data-id="element-130">
                {title}
              </h3>
              <div className="mt-auto w-full h-1 bg-green-500/30 rounded-full" data-id="element-131"></div>
            </div>}
        </div>
        {/* Right side: Content */}
        <div className="w-full md:w-2/3 text-left" data-id="element-132">
          <div className="flex items-center gap-2 mb-4" data-id="element-133">
            <Gift className="w-8 h-8 text-pink-500" data-id="element-134" />
            <h2 className="text-2xl md:text-3xl font-black text-gray-900 uppercase" data-id="element-135">
              BONO {bonusNumber}: <span className="text-black" data-id="element-136">{title}</span>
            </h2>
          </div>
          {description && <p className="text-lg text-gray-700 font-medium mb-4 leading-relaxed" data-id="element-137">
              {description}
            </p>}
          {features && features.length > 0 && <ul className="space-y-2 mt-4" data-id="element-138">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-2" data-id="element-139">
                  <div className="mt-1.5 min-w-4 min-h-4 rounded-full border border-gray-300 flex items-center justify-center" data-id="element-140">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-141"></div>
                  </div>
                  <span className="text-gray-700 font-medium text-lg" data-id="element-142">
                    {feature}
                  </span>
                </li>)}
            </ul>}
        </div>
      </div>
    </div>;
}